
import gaEvents from '../../../shared/analyticsEvents';
import axios from 'axios';
import { ShareInfoRequest, ShareInfoRequestResponse } from './ShareLink.interfaces';
import { ERROR_RESPONSE, ErrorResponse } from '../../../shared';


export const SHARE_INFO_REQUEST_RESPONSE = 'ShareInfoRequestResponse';

const opts = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
const width = 550;
const height = 420;
const devUrlOrigin = 'http://poseidonaws.ets-naepanalysis-prod.c.ets.org/nqt';
// Browser window height - accounts for browser inconsistencies
const getWinHeight = () => {
  return window.innerHeight || (document.documentElement || document.body).clientHeight;
};
// Browser window width - accounts for browser inconsistencies
const getWinWidth = () => {
  return window.innerWidth || (document.documentElement || document.body).clientWidth;
};
// handle local url for dev

const getWinOpts = () : string => {
  const winHeight = getWinHeight();
  const winWidth = getWinWidth();
  const left = Math.round(winWidth / 2 - width / 2);
  const top = winHeight > height ? Math.round(winHeight / 2 - height / 2) : 0;
  return opts + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
};

export const getUrlEncoded = () :string => {
  return encodeURI(getUrl());
};

export const getUrl = () :string => {
  const appUrl = document.location.href.replace(/\/searchquestions/g, '');
  return (document.location.origin.includes('local')) ?
    (devUrlOrigin + document.location.search) :
    (appUrl);
};

export const getShareInfo = async (request: ShareInfoRequest, abortController: AbortController ): Promise<ShareInfoRequestResponse | ErrorResponse> => {

  const response = axios.post<ShareInfoRequestResponse>('api/QueryResults/GetShareInfo', { ...request }, {signal: abortController.signal})
    .then(res => {
      return { ...res.data, __typename: SHARE_INFO_REQUEST_RESPONSE };
    }).catch((errMsg: string) => ({ errMsg, __typename: ERROR_RESPONSE }));

  return response;
};

export const tabToShareTop = (goToTop: boolean) => (e: React.KeyboardEvent): void => {
  if (!goToTop) { return; }
  if (e.key === 'Tab' && !e.shiftKey) {
    const facebookButton = document.getElementById('nqt-shl--facebook') as HTMLElement;
    if (facebookButton) {
      e.preventDefault();
      facebookButton.focus();
    }
  }
};

export const tabToShareBottom = (e: React.KeyboardEvent): void => {
  if (e.key === 'Tab' && e.shiftKey) {
    const onLineTestButton = document.getElementById('nqt-shl--online-test') as HTMLElement;
    if (onLineTestButton.hasAttribute('disabled')) {
      const onLineDownloadButton = document.getElementsByClassName('nqt-shl-download-link') as HTMLCollectionOf<HTMLButtonElement>;
      e.preventDefault();
      onLineDownloadButton[0].focus();
    } else {
      e.preventDefault();
      onLineTestButton.focus();
    }
  }
};

export const openFacebookShare = (faceBookUrl: string, targetUrl: string) => () : void => {
  try {
    const href = faceBookUrl + targetUrl + '&quote=' + encodeURIComponent(window.document.title);
    window.open(href, 'facebook-share-dialog', getWinOpts());
    gaEvents.onGA4ShareLink('Facebook');
  }
  catch (error) {
    console.error(error);
  }
};

export const openTwitterShare = (twitterUrl: string, targetUrl: string) => () : void => {
  try {
    const href = twitterUrl + encodeURI(targetUrl) + '&text=' + encodeURIComponent(window.document.title);
    window.open(href, 'twitter-share-dialog', getWinOpts());
    gaEvents.onGA4ShareLink('Twitter');
  }
  catch (error) {
    console.error(error);
  }
};

export const openShareEmail =  (emailUrl: string, targetUrl: string) => () : void => {
  try {
    const quoteOrText = window.document.title || 'The NAEP Questions Tool';
    window.location.href = emailUrl + quoteOrText + '&body=' + targetUrl;
    gaEvents.onGA4ShareLink('Email');
  }
  catch (error) {
    console.error(error);
  }
};

const forceShowQuestionPanel = () : void => {
  const sidePanelButton = document.getElementById('show-hide-qp') as HTMLButtonElement;
  // check to see if the side button is disabled, should not happen
  if (sidePanelButton.classList.contains('nqt-sq--disabled')) { return;}
  if (!sidePanelButton.classList.contains('nqt-sq--sp-showing')) {
    sidePanelButton.click();
  }
};

export const openPublishPanel = () : void => {
  forceShowQuestionPanel();
  const target = document.querySelector('button.nqt-ptp--accordion-button.accordion-button') as HTMLButtonElement;
  const indicator = document.getElementById('ptpCollapseOne') as HTMLElement;
  const isIndicatorShown = indicator && indicator.classList.contains('show');
  if (target && ((!indicator || !isIndicatorShown) || target.classList.contains('collapsed'))) {
    target.click();
  }
  window.setTimeout(() => {
    const firstInput = document.getElementById('nqt-ptp--total-test-takers-control') as HTMLInputElement;
    if (firstInput) {
      firstInput.focus();
      window.scrollTo(0, firstInput.getBoundingClientRect().y - 100 );
    }
  }, 10);
};

export const openSeeHowStudentsPerformedPanel = () : void => {
  forceShowQuestionPanel();
  const target = document.querySelector('button.nqt-xp--accordion-button.accordion-button') as HTMLButtonElement;
  const indicator = document.getElementById('collapseTwo') as HTMLElement;
  const isIndicatorShown = indicator && indicator.classList.contains('show');
  if (target && ((!indicator || !isIndicatorShown) || target.classList.contains('collapsed'))) {
    target.click();
  }
  window.setTimeout(() => {
    const firstInput = document.getElementById('nqt-fieldset') as HTMLInputElement;
    if (firstInput) {
      firstInput.focus();
      window.scrollTo(0, firstInput.getBoundingClientRect().y - 100 );
    }
  }, 10);
};

export const openDownloadPanel = () : void => {
  forceShowQuestionPanel();
  const target = document.querySelector('button.nqt-dp--accordion-button.accordion-button') as HTMLButtonElement;
  const indicator = document.getElementById('collapseThree') as HTMLElement;
  const isIndicatorShown = indicator && indicator.classList.contains('show');
  if (target && ((!indicator || !isIndicatorShown) || target.classList.contains('collapsed'))) {
    target.click();
  }
  window.setTimeout(() => {
    const firstInput = document.querySelector('.dp-checkbox-container .nqt-checkbox') as HTMLLabelElement;
    if (firstInput) {
      firstInput.focus();
      window.scrollTo(0, firstInput.getBoundingClientRect().y - 50 );
    }},
  10);
};

export const tabToShareBackToPanel = (e: React.KeyboardEvent): void => {
  if (e.key === 'Tab' && e.shiftKey) {

    const downloadButton = document.getElementById('nqt-shl--download-button') as HTMLElement;
    e.preventDefault();
    downloadButton.focus();
  }
  else if(e.key === 'Tab' && !e.shiftKey){
    const target = document.querySelector('#nqt-question-item-list tr.selected-row') as HTMLButtonElement;
    if (target.classList.contains('selected-row')) {
      e.preventDefault();
      target.focus();
    }

  }
};

export const tabBackToSelectedRow = (e: React.KeyboardEvent): void => {
  if (e.key === 'Tab' && e.shiftKey) {

    const target = document.querySelector('#nqt-question-item-list tr.selected-row') as HTMLButtonElement;
    const targetIndex = target.id.match(/\d+/g)?.map(Number);
    
    if (target.classList.contains('selected-row')) {
      if(targetIndex){
        const index = targetIndex[0];
        const gridItemAnchor = document.getElementById('gi-anchor-'+index) as HTMLButtonElement;
        e.preventDefault();
        gridItemAnchor.focus();
      } else {
        e.preventDefault();
        target.focus();
      }
    } else {
      e.preventDefault();
    }
  }
};
  